import { render, staticRenderFns } from "./matriz-sustancias-editar.vue?vue&type=template&id=2a384c02&"
import script from "./matriz-sustancias-editar.vue?vue&type=script&lang=js&"
export * from "./matriz-sustancias-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports